import { AbstractParser } from "../../parser";
import {
  CompanyMasterData,
  CompanyFederalOfficerBillingInfo,
  CompanyFederalOfficerActivityInfo,
  CompanyFederalOfficerSocialPartnerInfo,
} from "src/app/ui/models/domains/pbm/companies/company-master-data";
import { parseCompanyMasterData } from "./company-parse-functions";

export class SearchCompanyFromMDMParser extends AbstractParser<CompanyMasterData> {
  parse(payload: any): CompanyMasterData {
    return parseCompanyMasterData(payload);
  }
}
